<template>
    <DppCtaCardPresentational
        :isRDC = dpp.isRDC
        :isRentals = dpp.isRentals
        :ctaInfoIconClass = dppCtaInfo.icon
        :ctaInfoTitleText = dppCtaInfo.title
        :ctaInfoSubtitleText = dppCtaInfo.sub
        :ctaInfoCtaText = dppCtaInfo.cta
        :ctaInfoSectionText = dppCtaInfo.section
        :onCTAClick = openAssignedAgentHotlead
    />
</template>

<script src="./dpp-ctacard.js"></script>
